import React from 'react';
import classNames from 'classnames';
import TextArea from 'components/shared/debouncedTextArea';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';

const RoundedInput = props => {
  const {
    value,
    onChange,
    labelText,
    placeholderText = '',
    id,
    singleLine = false,
    wide = false,
    hasError = false,
    className = '',
    textClassName = 'llui-text-subheader',
    showStrongErrors = false,
  } = props;

  const classes = classNames(
    `${textClassName} p-16 border-1 bdrs-base h-56 w-fill`,
    {
      'border-navy-dark bd-focus-navy-dark bg-gray-lightest':
        !!hasError && !showStrongErrors,
      'rounded-input-strong-error': !!hasError && showStrongErrors,
      'border-gray-light bd-focus-gray bg-gray-lightest': !hasError,
    },
  );

  const containerClasses = classNames(`${className} d-f fd-c`, {
    'w-85p m-w-fill': !wide,
    'w-fill': !!wide,
  });
  return (
    <div className={containerClasses}>
      {labelText && (
        <label htmlFor={id} className="mt-16 mb-8 as-fs fs-n">
          <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>{labelText}</Text>
        </label>
      )}
      <TextArea
        id={id}
        value={value}
        className={classes}
        onChange={onChange}
        placeholder={placeholderText}
        singleLine={singleLine}
      />
    </div>
  );
};

export default RoundedInput;
